export const getNumberOfDays = (expiryDate: Date) => {
  const currentDate = new Date()
  const timeDiff = new Date(expiryDate).getTime() - currentDate.getTime()
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))
  if (daysDiff > 0) {
    return daysDiff
  } else if (daysDiff < 0) {
    return daysDiff
  }
  return 0
}

export const getInputDueDate = (dueDate: any) => {
  const date = new Date(dueDate)

  // Extract the year, month, and day from the date object
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-based, so add 1
  const day = String(date.getUTCDate()).padStart(2, '0') // Add leading zero if necessary

  // Construct the date string in the format YYYY-MM-DD
  return `${year}-${month}-${day}`
}
